export default "__VITE_ASSET__HaqfxIgY__"